import React from "react"

import Flex from "@irati/ui/src/Flex"
import Hr from "@irati/ui/src/Layout/Hr"
import {Label, H4} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import theme from "@irati/ui/src/global/theme"
import {TooltipProps} from "recharts"
import {ValueType, NameType} from "recharts/src/component/DefaultTooltipContent"

import {TooltipWrapper} from "./styled"

const BenchmarkTooltip = ({active, payload, label}: TooltipProps<ValueType, NameType>) => {

  if (!active || !label || payload?.length === 0) return null

  return (
    <TooltipWrapper padding={2} margin={2}>
      <Label color={theme.colors.primary1}>
        <FormattedMessage id="admin.components.benchmark.tooltip.allIndustry" />
      </Label>
      <Flex marginTop={1} marginBottom={1} justifyContent="space-between">
        <Label>{label}</Label>
        <H4>{Math.round(payload[1]?.value)}%</H4>
      </Flex>
      <Hr />
      <Label>
        <FormattedMessage id="admin.components.benchmark.tooltip.yourComapany" />
      </Label>
      <Flex marginTop={1} marginBottom={1} justifyContent="space-between">
        <Label>{label}</Label>
        <H4>{Math.round(payload[0]?.value)}%</H4>
      </Flex>
    </TooltipWrapper>
  )
}

export default BenchmarkTooltip
